export default function(value) {
  return !value || value.length === 0 ? 'Value is required' : undefined;
}
